import { Box, Button, IconButton, Tooltip } from '@mui/material';
import React, { useState } from 'react'
import CloseIcon from '@mui/icons-material/Close';
import CustomDialog from '../dialogs/CustomDialog';
import { useArchiveProductSuggestion } from '../../hooks/useProductSuggestion';
import { useRejectTeamInvitationRequest } from '../../hooks/useTeamInvitations';
import CustomButton from 'components/buttons/CustomButton/CustomButton';
import { rejectTeamInvitationRequest } from 'services/invitationService';
import { colors } from 'styles/colors';
import XIcon from 'icons/XIcon';
import { snackbarService } from 'services/snackbarService';

interface Props {
  id: string;
  refetch?: () => void;
}

function RejectTeamRequestActionButton({ id, refetch }: Props) {
  const [open, setOpen] = useState<boolean>(false);

  const { mutate: rejectRequest, isLoading } = useRejectTeamInvitationRequest(
    () => {
      setOpen(false);
      snackbarService.showSnackbar('Request has been rejected successfully', 'success');
      refetch?.();
    },
    () => { },
  );

  const handleReject = () => {
    rejectRequest(id);
  }

  return (
    <>
      <Tooltip title={'Reject'}>
        <IconButton
          onClick={() => setOpen(true)}
          sx={{
            width: 25,
            height: 25,
            backgroundColor: colors.error,
            borderRadius: '4px',
            padding: 0,
            '&:hover': {
              backgroundColor: colors.error,
            },
          }}
        >
          <XIcon size={15} color={'white'} />
        </IconButton>
      </Tooltip>
      <CustomDialog
        open={open}
        title='Reject request'
        message={`Are you sure you want to reject this request?`}
        buttons={[
          <CustomButton
            key='cancel'
            text="Cancel"
            variant='outlined'
            color='primary'
            onClick={() => setOpen(false)}
            disabled={isLoading}
          />,
          <CustomButton
            key='reject'
            text="Reject"
            color='primary'
            onClick={handleReject}
            loading={isLoading}
          />
        ]}
      />
    </>
  )
}

export default RejectTeamRequestActionButton;